/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/gateways';
import '../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "networknumerics": {
            "nested": {
              "NetworkNumerics": {
                "fields": {
                  "gatewayName": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "acquirerName": {
                    "type": ".squareup.common.gateways.AcquirerName",
                    "id": 8,
                    "rule": "optional"
                  },
                  "amexNumerics": {
                    "type": ".squareup.payments.networknumerics.AmexNumerics",
                    "id": 2
                  },
                  "chaseNumerics": {
                    "type": ".squareup.payments.networknumerics.ChaseNumerics",
                    "id": 3
                  },
                  "discoverNumerics": {
                    "type": ".squareup.payments.networknumerics.DiscoverNumerics",
                    "id": 4
                  },
                  "mastercardNumerics": {
                    "type": ".squareup.payments.networknumerics.MastercardNumerics",
                    "id": 5
                  },
                  "nyceNumerics": {
                    "type": ".squareup.payments.networknumerics.NyceNumerics",
                    "id": 6
                  },
                  "visaNumerics": {
                    "type": ".squareup.payments.networknumerics.VisaNumerics",
                    "id": 7
                  }
                },
                "nested": {
                  "network_numerics": {
                    "oneof": ["amexNumerics", "chaseNumerics", "discoverNumerics", "mastercardNumerics", "nyceNumerics", "visaNumerics"]
                  }
                }
              },
              "AmexNumerics": {
                "fields": {
                  "serviceEntity": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ChaseNumerics": {
                "fields": {
                  "transactionDivision": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessApplicationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DiscoverNumerics": {
                "fields": {
                  "acquiringInstitutionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardAcceptorId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MastercardNumerics": {
                "fields": {
                  "acquirerCountry": {
                    "type": ".squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "acquirerReferenceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "acquiringInstitutionId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardAcceptorId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clearingAcquiringInstitutionId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "forwardingInstitutionId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "groupSignOnCode": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "independentSalesOrganizationId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "interchangeRegion": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "mastercardAssignedId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "merchantPaymentGatewayId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "paymentFacilitatorId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "processorId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "routingTransitNumber": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "supportedSellerCountries": {
                    "type": ".squareup.common.countries.Country",
                    "id": 15,
                    "rule": "repeated"
                  },
                  "transactionTypeId": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  }
                }
              },
              "NyceNumerics": {
                "fields": {
                  "acquiringInstitutionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardAcceptorId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardAcceptorTerminalId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "networkTerminalId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "acquirerNetworkId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sponsorBankId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "VisaNumerics": {
                "fields": {
                  "acquiringInstitutionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessApplicationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardAcceptorId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantVerificationValue": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "specialConditionIndicator": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "acquiringRegion": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.NetworkNumerics && !$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.AmexNumerics && !$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.ChaseNumerics && !$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.DiscoverNumerics && !$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.MastercardNumerics && !$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.NyceNumerics && !$root.nested?.squareup?.nested?.payments?.nested?.networknumerics?.nested?.VisaNumerics) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE NetworkNumerics @ squareup/payments/network_numerics.proto at 11:1
 */
export const NetworkNumerics = $root.lookupType('squareup.payments.networknumerics.NetworkNumerics');
fixType(NetworkNumerics);
Builder.createAndAttachToType(NetworkNumerics);
/**
 * SOURCE AmexNumerics @ squareup/payments/network_numerics.proto at 25:1
 */
export const AmexNumerics = $root.lookupType('squareup.payments.networknumerics.AmexNumerics');
fixType(AmexNumerics, {
  serviceEntity: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AmexNumerics);
/**
 * SOURCE ChaseNumerics @ squareup/payments/network_numerics.proto at 30:1
 */
export const ChaseNumerics = $root.lookupType('squareup.payments.networknumerics.ChaseNumerics');
fixType(ChaseNumerics, {
  transactionDivision: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ChaseNumerics);
/**
 * SOURCE DiscoverNumerics @ squareup/payments/network_numerics.proto at 37:1
 */
export const DiscoverNumerics = $root.lookupType('squareup.payments.networknumerics.DiscoverNumerics');
fixType(DiscoverNumerics, {
  acquiringInstitutionId: {
    notEmpty: true
  },
  cardAcceptorId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DiscoverNumerics);
/**
 * SOURCE MastercardNumerics @ squareup/payments/network_numerics.proto at 44:1
 */
export const MastercardNumerics = $root.lookupType('squareup.payments.networknumerics.MastercardNumerics');
fixType(MastercardNumerics, {
  acquiringInstitutionId: {
    notEmpty: true
  },
  cardAcceptorId: {
    notEmpty: true
  },
  interchangeRegion: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(MastercardNumerics);
/**
 * SOURCE NyceNumerics @ squareup/payments/network_numerics.proto at 79:1
 */
export const NyceNumerics = $root.lookupType('squareup.payments.networknumerics.NyceNumerics');
fixType(NyceNumerics, {
  acquiringInstitutionId: {
    notEmpty: true
  },
  cardAcceptorId: {
    notEmpty: true
  },
  cardAcceptorTerminalId: {
    notEmpty: true
  },
  networkTerminalId: {
    notEmpty: true
  },
  acquirerNetworkId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(NyceNumerics);
/**
 * SOURCE VisaNumerics @ squareup/payments/network_numerics.proto at 97:1
 */
export const VisaNumerics = $root.lookupType('squareup.payments.networknumerics.VisaNumerics');
fixType(VisaNumerics, {
  acquiringInstitutionId: {
    notEmpty: true
  },
  cardAcceptorId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(VisaNumerics);